import { Action, createReducer } from '@ngrx/store';
import * as fromState from './running-action.state';

const runningActionsReducer = createReducer(
    fromState.getInitialRunningActionState(),
);

export function reducer(state: fromState.RunningActionState | undefined = fromState.getInitialRunningActionState(), action: Action) {
    return runningActionsReducer(handleRunningActions(state, action), action);
}

const excludedRunningActionTypeSubstrings: string[] = ['@ngrx'];

function handleRunningActions(state: fromState.RunningActionState | undefined = fromState.getInitialRunningActionState(), action: Action): fromState.RunningActionState {
    const runningActions = [...state.actions];
    if (action.type.endsWith('success')) {
        const startActionType = action.type.substring(0, action.type.indexOf('success') - 1).replace(/\s/g, '');
        if (runningActions.includes(startActionType)) {
            runningActions.splice(runningActions.indexOf(startActionType, 0), 1);
        }

    } else if (action.type.endsWith('fail')) {
        const startActionType = action.type.substring(0, action.type.indexOf('fail') - 1).replace(/\s/g, '');
        if (runningActions.includes(startActionType)) {
            runningActions.splice(runningActions.indexOf(startActionType, 0), 1);
        }

    } else if (excludedRunningActionTypeSubstrings.find(ea => action.type.indexOf(ea) > -1) === undefined) {
        runningActions.push(action.type.replace(/\s/g, ''));
    }
    return { ...state, actions: runningActions };
}